export const RAV2_COURSE_TYPE_LEVEL_IDS = [
  '102001', '102002', '102003', '102004',
  '102005', '102006', '102007',
];

export function getRAv2LevelNumber(courseTypeLevelId) {
  const index = RAV2_COURSE_TYPE_LEVEL_IDS.indexOf(courseTypeLevelId);
  return index >= 0 ? index + 1 : undefined;
}

export function isHFv4CourseTypeLevelCode(fullCourseTypeLevelCode) {
  return typeof fullCourseTypeLevelCode === 'string' &&
    fullCourseTypeLevelCode.toLowerCase().startsWith('hfv4');
}

export function getExamBasePath({ fullCourseTypeLevelCode } = {}) {
  return isHFv4CourseTypeLevelCode(fullCourseTypeLevelCode) ?
    'exam-hfv4' :
    'exam';
}

export function getUnitReportBasePath({ fullCourseTypeLevelCode } = {}) {
  return isHFv4CourseTypeLevelCode(fullCourseTypeLevelCode) ?
    'unit-report-hfv4' :
    'unit-report';
}

export function getProgressReportBasePath({ fullCourseTypeLevelCode } = {}) {
  return isHFv4CourseTypeLevelCode(fullCourseTypeLevelCode) ?
    'progress-report-hfv4' :
    'progress-report';
}



// WEBPACK FOOTER //
// ./domain/CourseType/index.js